import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core';
import { ScrollSearchActeComponent } from "@shared/components/scroll-search-acte/scroll-search-acte.component";
import { SearchFormComponent } from "@shared/components/search-form/search-form.component";
import { SearchFormFullComponent } from "@shared/components/search-form-full/search-form-full.component";
import { MatTabGroup, MatTabsModule } from "@angular/material/tabs";
import { FormPresHospitComponent } from "./form-exploitation-hospit/form-pres-hospit/form-pres-hospit.component";
import { FormExecHospitComponent } from "./form-exploitation-hospit/form-exec-hospit/form-exec-hospit.component";
import { FormExploitationHospitComponent } from "./form-exploitation-hospit/form-exploitation-hospit.component";
import moment from 'moment';

@Component({
  selector: 'app-liste-demande-hospit-active',
  imports: [CommonModule, NgSelectModule, FormsModule, BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    ScrollSearchMedocPrestaComponent,
    BenefInfoComponent,
    PrestationInfoComponent,
    SearchMdicamentProComponent,
    SearchExamenLaboComponent, ScrollSearchActeComponent, SearchFormComponent, SearchFormFullComponent, MatTabGroup, MatTabsModule, FormExploitationHospitComponent],
  templateUrl: './liste-demande-hospit-active.component.html',
  styleUrl: './liste-demande-hospit-active.component.scss'
})
export class ListeDemandeHospitActiveComponent {
  selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any
  @Input() itemBeneficiare: any
  @Input() selectedDemandeHospitalisation: any
  @Input() type_hospitalisation: any
  cancelItemSelected = false
  @Input() refreshTriggerOrdonnance!: boolean;
  @Output() showExploitationHospitForm = new EventEmitter<any>();
  
  

  current_medicament_id: any = ''
  reload = false
  produit: string = '';
  clearText = false
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = []
  selectedItem: any = {}
  dossierActif: any = {}
  prestationActive: any = {}
  itemsElement: any = []


  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule'

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {}
  itemToSave: any = {}
  itemsModePrescription = [{ code: 'produit', libelle: 'Produit' }, { code: 'molecule', libelle: 'Molécule' }]
  // model: NgbDateStruct | undefined;
  fileName1: any;
  currentFile: any;
  selectedDemande: any = []
  itemsAffection: any;
  itemsPrescription: any;
  selectedPrescription: any;
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  garantie_id: any;
  itemsDemandeHospitalisation: any;
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = {}
    this.itemToSave.mode_prescription = 'produit'
    // this.getItemsAffection()
    this.itemToSave.date_prescription = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1, // getMonth() returns 0-11
      day: new Date().getDate()
    };
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire()
  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error'
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      }
    );
  }


  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }



  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder = this.input_option == 'MAT' ? 'Entrez numéro matricule' : 'Entrez numéro cnam'
  }

  
  getItemsDemandeHospitalisationActive() {
    if (!this.itemBeneficiare.id)
      return

    this.selectedDemande = {}
    let request = {
      index: 0,
      size: 1000,
      is_hospit: true,
      data: {
        beneficiaire_id: this.itemBeneficiare.id,
        prestataire_id: this.user.prestataire_id,
      },
    };

    this.restClient.post('prescriptionActe/getByCriteria', request).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsDemandeHospitalisation = res.items;
          if (this.itemsDemandeHospitalisation && this.itemsDemandeHospitalisation.length) {
            this.itemsDemandeHospitalisation.map((ip: any) => {
              ip.is_active = false;
              if (ip.duree_accord && ip.date_entree) {
                ip.date_sortie = moment(ip.date_entree).add(ip.duree_accord, 'days');
              }
            });
          }
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsDemandeHospitalisation = [];
        }
      },
      error: (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsDemandeHospitalisation = [];
      }
    });
  }

  confirmSaveItem(item?: any) {
   
        Swal.fire({
          title: 'Cloture/sortie',
          text: 'Souhaitez-vous poursuivre cette action?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0665aa',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
        }).then((result) => {
          if (result.value) {
            this.saveItems(item);
          }
        });
      }

  confirmDemandeProlongation(item?: any) {
   
        Swal.fire({
          title: 'Demande de prolongation',
          text: 'Souhaitez-vous poursuivre cette action?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0665aa',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
        }).then((result) => {
          if (result.value) {
            this.saveItems(item);
          }
        });
      }
    
      saveItems(item?: any) {
        item.is_sortie=true
        item.is_clotured=true
        item.date_sortie=moment()
        item.date_clotured=moment()
    
        let file_data = '';
        if (this.currentFile && Object.keys(this.currentFile).length) {
          file_data = this.currentFile;
        }
        let request = {
          datas: [{...item}],
        };
    
        this.restClient.post('demandeHospitalisation/update', request).subscribe(
          (res: any) => {
            // this.isLoading = false;
            if (res && !res['hasError']) {
              this.utilities.showSweetNotification(
                res['status']['message'],
                'succes'
              );
              // this.goNext()
              // this.imprimerFacture(res.item)
              this.getItemsDemandeHospitalisationActive()
            } else {
              this.utilities.showSweetNotification(
                res['status']['message'],
                'error'
              );
            }
    
          },
          (error) => {
            this.utilities.showSweetNotification(error, 'error');
          }
        );
      }




  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() { }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }


showRefusMessage(item:any){
  Swal.fire({
        title: 'Commentaire validateur',
        text: item.commentaire_validateur,
        icon: 'info',
        // showCancelButton: true,
        confirmButtonColor: '#0665aa',
        // cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Non',
      }).then((result) => {
       
      });

}
  onSelectRow(item: any): void {
    // if (this.isExpired(item.date_expiration)) return;
    if(item.type_hospitalisation_codification =='HM' || item.type_hospitalisation_codification =='HC'){
      if (item.is_expired || !item.is_validated || item.is_sortie || item.is_clotured) return;
      this.selectedDemande = { ...item }
    }
    else if(item.type_hospitalisation_codification =='HC'){
      if (item.is_expired || !item.is_validated || item.is_sortie || item.is_clotured || !item.is_intervention_date) return;
      this.selectedDemande = { ...item }
    }

    

    this.itemsDemandeHospitalisation.forEach((p: any) => p.is_active = false);
    item.is_active = true;
    this.showExploitationHospitForm.emit(item)
  }

  isExpired(expirationDate: string | Date): boolean {
    if (!expirationDate) return false; // Handle cases with no expiration date

    const expDate = new Date(expirationDate);
    const today = new Date();

    // Compare dates (ignoring time)
    return expDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ', changes)
    if (changes['itemBeneficiare'] && changes['itemBeneficiare'].currentValue) {
      console.log("changes['itemBeneficiare']: ", changes['itemBeneficiare'])
      this.itemBeneficiare = changes['itemBeneficiare'].currentValue
      this.getItemsDemandeHospitalisationActive()

    }
  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event)
    this.selectedItem = event || {}
  }
  onSelectMedocPro(event: any) {
    console.log('current medoc', event)
    this.selectedItem = event || {}
    // getTarifActe()
    this.itemToAdd.quantite = 1
    // this.onAddItemToList()
  }

  goNext() {
    this.onGoToTab.emit('pharmacie')
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsElement.splice(index, 1);
    }
  }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event
      this.authService.setActiveBeneficiaire(event)
      this.itemConsultation = {}
      this.beneficiaireAutOselect = this.itemBeneficiare
      this.getItemsDemandeHospitalisationActive()
    }
    else {
      this.authService.setActiveBeneficiaire({})
      this.beneficiaireAutOselect = {}
    }

  }

    reloadData(event:any){
    console.log('Prescription done')
    
  }
  onUpdateParent(event:any){
    this.getItemsDemandeHospitalisationActive()

  }
  

}
